import { MutableRefObject, useEffect } from "react"

export default function useOnClickOutside(ref: MutableRefObject<HTMLDivElement>, handler: (event: Event) => void) {
  useEffect(
    () => {
      const listener = (event: Event) => {
        if (!ref.current || ref.current.contains(event.target as Node)) {
          return
        }
        if (handler)
          handler(event)
      }
      document.addEventListener("mousedown", listener)
      document.addEventListener("touchstart", listener)
      return () => {
        document.removeEventListener("mousedown", listener)
        document.removeEventListener("touchstart", listener)
      }
    },

    [ref, handler]
  )
}
